/* tslint:disable */
/* eslint-disable */
/**
 * Scrivio Client Portal Authentication API
 * Authentication API for the Scrivio Client Portal.  ## Overview These endpoints support the passwordless Email Link authentication flow for clients. Clients are end-users (not healthcare workers) who access the client portal at mijn.scrivio.nl.  ## Authentication Flow 1. Client enters email on portal login page 2. Frontend calls `/api/client-auth/check-email` 3. The **backend** decides whether the address names a client record, and sends    either the Firebase Email Link or a note saying no record is registered on    that address. The response is the same either way. 4. Client clicks magic link in email 5. Frontend calls `/api/client-auth/complete-signin` after Firebase auth completes 6. Backend sets custom claims and links Firebase user to Client entity  Step 3 used to be the frontend\'s: it read the uniform 200 as \"go ahead\" and sent a Firebase link to every address typed into the form, including addresses no client record named — which created an orphaned Firebase account the moment the link was clicked (#3863). A decision the client may not know cannot be a decision the client makes.  ## Error Responses All error responses follow RFC 7807 Problem Details format. 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@scrivio.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';

export const BASE_PATH = "https://api.scrivio.nl".replace(/\/+$/, "");

export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

export interface RequestArgs {
    url: string;
    options: RawAxiosRequestConfig;
}

export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath ?? basePath;
        }
    }
};

export class RequiredError extends Error {
    constructor(public field: string, msg?: string) {
        super(msg);
        this.name = "RequiredError"
    }
}

interface ServerMap {
    [key: string]: {
        url: string,
        description: string,
    }[];
}

export const operationServerMap: ServerMap = {
}
